export { InputConsumer } from './InputConsumer';
